import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpService } from '../../http.service';
import { Subscription } from 'rxjs';
import { Meta } from '@angular/platform-browser';
import { LoginService } from 'src/app/login.service';
import { stateOptions } from '../,,/../../website-js/stateOptions';

@Component({
  selector: 'app-company-form-leads',
  templateUrl: './company-form-leads.component.html',
  styleUrls: ['./company-form-leads.component.scss']
})
export class CompanyFormLeadsComponent implements OnInit, OnDestroy  {

  stateOptions = stateOptions;
  constructor(
    public _router: Router,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    public _httpService: HttpService,
    private meta: Meta,
    public _loginService: LoginService,
    ) {
    this.checkParams();
    this.titleService.setTitle((this.item.pagetitle ? this.item.pagetitle : 'Form') + ' | VeEX Inc. | The Verification EXperts');
  }
  countries: any;

  retemail: string;
  retlastName: string;
  reterror: string;
  retsuccess: string;

  firstName: string;
  lastName: string;
  company: string;
  title: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  state: string;
  zipCode: string;
  countryCode: string;
  email: string;
  phoneArea: string;
  phoneNumber: string;
  phoneNumberC: string = '';
  error: string;
  success: string;
  emailsubject: string;
  plink: string = '';

  countryObject = {
    code: '',
    region: '',
    tel_code: ''
  };

  copyemailPref = false;
  item = {
    item: '',
    subject: '',
    pagetitle: '',
    formtitle:'',
    imgurl: '',
    formid: '',
    subtitle: '',
    date: '',
    time: '',
    place: '',
    address: '',
    country: ''
  };

  downloaditems = {
    "1": {
      item: 'Caracterización de un OTDR y la maleta de herramientas para xPON/FTTX',
      subject: 'FX150+ OTDR Conference (Costa Rica)',
      pagetitle: 'Conference Form',
      formtitle: 'FX150+OTDR Conference',
      imgurl: './assets/images/sidebar/conferencemario.webp',
      formid: 'b3ac55a3-0004-4b63-b00e-e6fc1c95d864',
      subtitle: 'Demostración en vivo de Mini OTDR FX150+ y accesorios para validación y resolución de fallas en redes de FO.',
      date: 'Friday Nov 11th 2022',
      time: '9:00 - 12:00 HRS Central America Time',
      place: 'NEXCON Costa Rica',
      address: 'Antiguo Mall Internacional Local 101, Alajuela',
      country: 'Costa Rica',
    },
    "2": {
      item: 'Redes FTTx/PON',
      subject: 'FTTx/PON Service Analyzer Application Guide (Spanish)',
      pagetitle: 'Redes FTTx/PON Form',
      formtitle: 'Redes FTTx/PON Form',
      imgurl: 'https://www.veexinc.com/assets/images/sidebar/D08-00-114_A00_PON_ESP_Page_01_SM.webp',
      formid: '8e1e4f77-9075-454a-8d05-5e17fd7d6b7d',
      subtitle: 'Guía de Aplicación del Analizador de Servicios',
    },
    "3": {
      item: 'Redes FTTx/PON Networks',
      subject: 'FTTx/PON Networks Test Solutions Application Guide (Spanish)',
      pagetitle: 'Redes FTTx/PON Networks Form',
      formtitle: 'Redes FTTx/PON Networks Form',
      imgurl: 'https://www.veexinc.com/assets/images/sidebar/D08-00-115_A00_PON_Solution_Guide_ESP_Page_01.webp',
      formid: 'de24e0a0-ce84-47b1-bd9f-767c9f17ed94',
      subtitle: 'Guía de Aplicación de Soluciones de Prueba',
    },
    "4": {
      item: 'Entrenamiento completo FX150+ OTDR  para redes Punto-a-Punto, PON-B y PON-U',
      subject: 'Entrenamiento completo FX150+ OTDR  para redes Punto-a-Punto, PON-B y PON-U (Spanish)',
      pagetitle: 'Entrenamiento completo FX150+ OTDR  para redes Punto-a-Punto, PON-B y PON-U Form',
      formtitle: 'Entrenamiento completo FX150+ OTDR  para redes Punto-a-Punto, PON-B y PON-U Form',
      imgurl: 'https://www.veexinc.com/assets/images/sidebar/FX150+_intro_cover_1280x720.webp',
      formid: 'e8cca758-d689-4d9b-8b86-ee482a248636',
      subtitle: `Video de entrenamiento completo con demostración de uso de Mini OTDR de VeEX FX150+ en redes Punto-a-Punto, PON-B y PON-U.<br><p class="blue fw-bold">Por favor regístrate para acceder al seminario</p>`,
    },
    // "5": {
    //   item: 'TITLE',
    //   subject: 'SUBJECT',
    //   pagetitle: 'PGE TITLE',
    //   formtitle: 'FORM TITLE',
    //   imgurl: './assets/images/sidebar/conferencemario.webp',
    //   formid: 'b3ac55a3-0004-4b63-b00e-e6fc1c95d864',
    //   subtitle: 'subtitle',
    //   date: 'Friday Nov 11th 2022',
    //   time: '9:00 - 12:00 HRS Central America Time',
    //   place: 'NEXCON Costa Rica',
    //   address: 'Antiguo Mall Internacional Local 101, Alajuela',
    //   country: 'Costa Rica',
    // },
  };

  cust: any;

  formid: string;
  pageurl: string;

  subs: Subscription[] = [];

  ngOnInit(): void {
    this.subs.push(this._httpService.getCountry().subscribe((data) => {
      // console.log(data);
      this.countries = data.result.country;
    }));
    if (localStorage.getItem('user')) {
      this.cust = this._loginService.getCust();
      // console.log(this.cust);
      this.fillForm();
    } else if (localStorage.getItem('forminfo')) {
      this.cust = JSON.parse(localStorage.getItem('forminfo'));
      // console.log(this.cust);
      this.fillForm();
    }
    this.checkParams();
    this.pageurl = window.location.href;
  }

  checkParams(): void {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      // console.log(params);
      this.plink = params.product;
      if (document.getElementById('formfill')) {
        const element1 = document.getElementById('formfill');
        element1.className = 'show';
      }
      if(this.downloaditems[params.f]) {
        this.item = this.downloaditems[params.f];
        this.meta.updateTag({
          name: 'twitter:image',
          content: this.item.imgurl
        });
        this.meta.updateTag({
          property: 'og:image',
          content: this.item.imgurl
        });
        this.formid = this.item.formid;
      } else {
        // if (document.getElementById('docredirect')) {
        //   const element = document.getElementById('docredirect');
        //   element.className = 'show';
        // }
        if (document.getElementById('formfill')) {
          const element1 = document.getElementById('formfill');
          element1.className = 'collapse';
        }
      }
    });
  }

  numberOnly (e) {  // Accept only alpha numerics, not special characters 
    // console.log(e);
    
    const regex = new RegExp("^[0-9 ]+$");
    const str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
        return true;
    }

    e.preventDefault();
    return false;
  }

  onPaste(e) {
    e.preventDefault();
    return false;
  }

  fillForm(): void {
    this.firstName = this.cust.first_name;
    this.lastName = this.cust.last_name;
    this.email = this.cust.email;
    // this.phoneNumber = this.cust.telephone ? this.cust.telephone.replace(/[^\d\+]/g,"") : this.cust.phone_no.replace(/[^\d\+]/g,"");
    this.company = this.cust.company_name ? this.cust.company_name : this.cust.company;
    this.title = this.cust.title;
    this.address1 = this.cust.address_1 ? this.cust.address_1 : this.cust.address1;
    this.city = this.cust.city;
    this.state = this.cust.state;
    this.zipCode = this.cust.zip_code;
    this.countryCode = this.cust.country_code;
    this.countryObject.code = this.cust.country_code;
    this.phoneArea = this.cust.area_code;
  }

  downloadPDFButton(): void {
    // console.log('TESTTTTTTT', this.countryObject.code);
    if (!this.firstName || !this.lastName || !this.company || !this.title || !this.address1 ||
      !this.city || !this.zipCode || !this.countryCode || !this.phoneNumber || this.phoneNumber.length < 6 || !this.email) {
      this.error = 'Please fill out all of the required information. Make sure all information is valid.';
      this.success = '';
      // console.log(this.copyemailPref);
    } else {
      this.error = '';
      this.formSubmit();
    }
  }

  getReturningCust(): void {
    this.retsuccess = '';
    this.reterror = '';
    if (!this.retemail || !this.retlastName) {
      this.reterror = 'Please fill out all of the required information';
      this.retsuccess = '';
    } else {
      const returningcust = {
        type: 'returning_form',
        email: this.retemail,
        last_name: this.retlastName
      };
      this.subs.push(this._httpService.veExAPI(returningcust).subscribe((data) => {
        if ((data as any).status_code === '000') {
          this.firstName = data.result.first_name;
          this.lastName = data.result.last_name;
          this.email = data.result.email;
          this.phoneNumber = data.result.phone_no.replace(/[^\d\+]/g,"");
          this.company = data.result.company ? data.result.company : ' ';
          this.title = data.result.title ? data.result.title : ' ';
          this.address1 = data.result.address1  ? data.result.address1 : ' ';
          this.address2 = data.result.address2;
          this.address3 = data.result.address3;
          this.city = data.result.city ? data.result.city : ' ';
          this.state = data.result.state;
          this.zipCode = data.result.zip_code ? data.result.zip_code : ' ';
          this.countryObject.code = data.result.country_code;
          this.countryCode = data.result.country_code ? data.result.country_code : ' ';
          this.countryObject.region = data.result.region ? data.result.region : ' ';
          this.formSubmit();
        } else if ((data as any).status_code === '003') {
          this.reterror = 'Please enter a valid email address';
          this.retsuccess = '';
        } else if ((data as any).status_code === '006') {
          this.reterror = 'This email does not exist';
          this.retsuccess = '';
        }
        // console.log(data);
      }));
    }
  }


  formSubmit(): void {
    this.success = 'Submitting Form';
    let hardcopy = '0';
    if (!this.address2) {
      this.address2 = ' ';
    }
    if (!this.address3) {
      this.address3 = ' ';
    }
    if (!this.state) {
      this.state = ' ';
    }
    if (!this.phoneArea) {
      this.phoneArea = ' ';
    }
    if (this.copyemailPref === true) {
      hardcopy = '1';
      this.emailsubject = '[HARDCOPY] ' + this.item.subject + ' | (from ' + this.city + ', ' + this.countryCode + ') | ' + '(' + this.countryObject.region + ')';
    } else {
      this.emailsubject = this.item.subject + ' | (from ' + this.city + ', ' + this.countryCode + ') | ' + '(' + this.countryObject.region + ')';
    }
    // this.phoneNumber = this.phoneNumberC + this.phoneNumber.replace(/[^\d\+]/g,"")
    const hubspotbody = {
      fields: [
        // {
        //   name: 'plink',
        //   value: this.plink?this.plink:' '
        // },
        {
          name: 'email',
          value: this.email
        },
        {
          name: 'firstname',
          value: this.firstName
        },
        {
          name: 'lastname',
          value: this.lastName
        },
        {
          name: 'phone',
          value: this.phoneNumber
        },
        {
          name: 'company',
          value: this.company
        },
        {
          name: 'jobtitle',
          value: this.title
        },
        {
          name: 'address',
          value: this.address1
        },
        {
          name: 'city',
          value: this.city
        },
        {
          name: 'state',
          value: this.state
        },
        {
          name: 'zip',
          value: this.zipCode
        },
        {
          name: 'country',
          value: this.countryObject.code
        },
        {
          name: 'lifecyclestage',
          value: 'lead'
        },
        {
          name: 'hs_lead_status',
          value: 'NEW'
        },
        {
          name: 'lead_source',
          value: 'Website-Online'
        },
        {
          name: 'region_global',
          value: (this.countryObject.code === 'US') ? (this.countryObject.code) : (this.countryObject.code === 'CA') ? (this.countryCode) : (this.countryObject.region === 'Caribbean') ? ('Carrabeans') : (this.countryObject.region)
        }
      ],
      context: {
        pageUri: this.pageurl,
        pageName: 'Company Form | VeEX Inc. | The Verification EXperts'
      },
      legalConsentOptions: {
        consent: {
          consentToProcess: true,
          text: 'I agree to allow VeEX Inc. to store and process my personal data.',
          communications: [{
            value: true,
            subscriptionTypeId: 999,
            text: 'I agree to receive marketing communications from VeEX Inc.'
          }]
        }
      }
    };
    const emailinfo = {
      type: 'email_form',
      first_name: this.firstName,
      last_name: this.lastName,
      company: this.company,
      title: this.title,
      address1: this.address1,
      address2: this.address2,
      address3: this.address3,
      city: this.city,
      state: this.state,
      zip_code: this.zipCode,
      country_code: this.countryObject.code,
      area_code: this.phoneArea,
      phone_no: this.phoneNumber,
      email: this.email,
      hard_copy: hardcopy,
      subject: this.emailsubject
    };
    // console.log(emailinfo);
    // console.log(hubspotbody);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this._httpService.postHubspotForm(this.formid, hubspotbody).toPromise().then((_result: any) => {
      console.log(_result);
      this.submitForm(emailinfo);
    }).catch(error => {
      console.log(error);
      this.submitForm(emailinfo);
      // console.log(error.error.errors);
      // if (error.error.errors[0].errorType === 'INVALID_EMAIL') {
      //   this.error = 'Please enter a valid email address';
      // } else if (error.error.errors[0].errorType === 'NUMBER_OUT_OF_RANGE') {
      //   this.error = 'Please enter a valid phone number';
      // }
      this.success = '';
    });
  }

  submitForm(info: any){
      this.subs.push(this._httpService.veExAPI(info).subscribe((data) => {
        // console.log(data);
        if ((data as any).status_code === '000') {
          localStorage.setItem('forminfo', JSON.stringify(info));
          // console.log(hubspotbody);
          this.error = '';
          if(this.formid == '8e1e4f77-9075-454a-8d05-5e17fd7d6b7d' || this.formid == 'de24e0a0-ce84-47b1-bd9f-767c9f17ed94' || this.formid == 'e8cca758-d689-4d9b-8b86-ee482a248636') {
            this._router.navigate(['/downloads'], {
              queryParams: {
                comments: this.item.formtitle,
                pass: 'true'
              }, queryParamsHandling: 'merge'
            });
          }else{
            this._router.navigate(['/company/contactus/success'], {queryParamsHandling: 'merge'});
          }
        } else if ((data as any).status_code === '003') {
          this.error = 'Please enter a valid Email address';
          this.success = '';
        } else if ((data as any).status_code === '002') {
          this.error = 'Please fill out all required fields';
          this.success = '';
        }
      }));
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getData(event): void {
    // if(event.options[event.selectedIndex].getAttribute('data-code') == 'US'){
    //   this.phoneNumberC = '+1';
    // } else {
    //   this.phoneNumberC = '+';
    // }
    this.countryObject.code = event.options[event.selectedIndex].getAttribute('data-code');
    this.countryObject.region = event.options[event.selectedIndex].getAttribute('data-region');
    this.countryObject.tel_code = event.options[event.selectedIndex].getAttribute('data-tel');
    console.log(this.countryObject.code, this.countryObject.region);

    this.phoneNumberC = `+${this.countryObject.tel_code}`;
    // this.phoneArea = this.phoneNumberC;
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }


}
